import React from 'react';

export const NotFound = () => {
    return (
        <div className="d-flex flex-column w-100 justify-content-center align-items-center">
            <h1>404</h1>
            <div>The page that you were looking for is not here!</div>
        </div>
    );
};